import API_URL from "../api/url";
import api from "../api/api";


export const login = async (payload) => {
  try {
    const response = await api.post(API_URL.postLogin, payload, {
      withCredentials: true,
      config: { showMessage: true },
    });
    return response;
  } catch (error) {
    throw error;
  }
};